<button
  type="button"
  class="language-switcher"
  [class.language-switcher--en]="idiomaActual === 'en'"
  (click)="cambiarIdioma()"
  [attr.aria-label]="etiquetaIdioma"
>
  <span class="language-switcher__option" [class.is-active]="idiomaActual === 'es'">
    <img src="assets/svgs/argentina.svg" alt="Argentina">
    <span>ES</span>
  </span>
  <span class="language-switcher__option" [class.is-active]="idiomaActual === 'en'">
    <img src="assets/svgs/usa.svg" alt="USA">
    <span>EN</span>
  </span>
</button>
